import classNames from 'classnames/bind';
import React from 'react';
import styles from './body.module.scss';
import Row from './Row';

const cx = classNames.bind(styles);

export type Props = React.ComponentPropsWithoutRef<'div'>;

export interface BodyComponent
  extends React.ForwardRefExoticComponent<
    Props & React.RefAttributes<HTMLDivElement>
  > {
  Row: typeof Row;
}

// eslint-disable-next-line react/display-name
const Body = React.forwardRef<HTMLDivElement, Props>(
  ({ children, ...props }, ref) => {
    return (
      <div ref={ref} className={cx('container')} {...props}>
        {children}
      </div>
    );
  }
) as BodyComponent;

Body.displayName = 'Body';
Body.Row = Row;

export default Body;
